import agents from './agents'
import languageModel from './language-model'
import marketplace from './marketplace'
import profiles from './profiles'
import profilesCategories from './profiles-categories'
import services from './services'
import settings from './settings'
import tokens from './tokens'
import ugcPersonas from './ugc-personas'

const ai = [
	{
		path: '/ai/providers/status',
		name: 'ai-providers-status',
		component: () => import('@/views/ai/providers/status.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
	{
		path: '/ai/dashboard',
		name: 'ai-dashboard',
		component: () => import('@/views/ai/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
	{
		path: '/ai/messages',
		name: 'ai-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
	{
		path: '/ai/newsletter',
		name: 'ai-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
	{
		path: '/ai/notifications',
		name: 'ai-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
	...agents,
	...settings,
	...profilesCategories,
	...profiles,
	...ugcPersonas,
	...services,
	...tokens,
	...languageModel,
	...marketplace,
	{
		path: '/ai/assistant-config',
		name: 'ai-assistant-config',
		component: () => import('@/views/ai/assistant/config.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
]

export default ai
